var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M15 20.1L6.9 12 15 3.9 17.1 6l-6 6 6 6-2.1 2.1z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }